import styled from 'styled-components'

const Container = styled.div`
  .modal--container {
    background: #252841;
    border-radius: 12px;
    padding: 2rem;
    min-width: 500px;
    max-width: 600px;

    @media (max-width: 768px) {
      min-width: 100%;
      padding: 1.5rem;
    }
  }

  header {
    margin-bottom: 2rem;
    text-align: center;

    h2 {
      font-size: 1.75rem;
      font-weight: 600;
      color: #fff;
      margin-bottom: 0.5rem;
    }

    p {
      color: rgba(255, 255, 255, 0.6);
      font-size: 0.95rem;
      line-height: 1.5;
    }
  }

  .form-content, .details-content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .info-box {
    background: rgba(79, 70, 229, 0.1);
    border: 1px solid rgba(79, 70, 229, 0.3);
    border-radius: 8px;
    padding: 1rem;

    p {
      color: rgba(255, 255, 255, 0.8);
      font-size: 0.9rem;
      line-height: 1.6;
      margin: 0;
    }
  }

  .rider-card {
    background: rgba(255, 255, 255, 0.05);
    border: 2px solid rgba(79, 70, 229, 0.3);
    border-radius: 12px;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;

    .rider-avatar {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 2rem;
      color: #fff;
    }

    .rider-info {
      width: 100%;
      text-align: center;

      h3 {
        font-size: 1.5rem;
        font-weight: 600;
        color: #fff;
        margin-bottom: 1rem;
      }

      .info-row {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.75rem;
        padding: 0.75rem;
        background: rgba(255, 255, 255, 0.03);
        border-radius: 8px;
        margin-bottom: 0.5rem;

        .icon {
          color: #4f46e5;
          font-size: 1rem;
          flex-shrink: 0;
        }

        span {
          color: rgba(255, 255, 255, 0.9);
          font-size: 0.95rem;
        }
      }
    }
  }

  .confirmation-box {
    background: rgba(16, 185, 129, 0.1);
    border: 1px solid rgba(16, 185, 129, 0.3);
    border-radius: 8px;
    padding: 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;

    .check-icon {
      color: #10b981;
      font-size: 1.5rem;
      flex-shrink: 0;
    }

    p {
      color: rgba(255, 255, 255, 0.8);
      font-size: 0.9rem;
      line-height: 1.6;
      margin: 0;
    }
  }

  .error-message {
    color: #ef4444;
    font-size: 0.875rem;
    margin-top: -0.5rem;
    padding: 0.5rem;
    background: rgba(239, 68, 68, 0.1);
    border-radius: 4px;
  }

  .button-row {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;

    button {
      flex: 1;
      padding: 0.875rem;
      font-size: 1rem;
      font-weight: 500;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s;

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    .btn-secondary {
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
      border: 1px solid rgba(255, 255, 255, 0.2);

      &:hover:not(:disabled) {
        background: rgba(255, 255, 255, 0.15);
      }
    }
  }
`

export default Container
